exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=checkbox].custom-control-input.before,\ninput[type=radio].custom-control-input.before {\n  background: grey !important;\n}", ""]);

// exports
